import { useMemo } from 'react';

export const useGetCurrentTab = (rootPath: string) => {
  const currentTab = useMemo(() => {
    return location.pathname.slice(rootPath.length).split('/').pop();
  }, [rootPath, location.pathname]);

  return currentTab;
};
